/**
 * useToast.ts - Hook to use toast notifications
 */

import { useEffect, useState, useCallback } from 'react';
import { toastService, Toast } from '../services/toastService';

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const unsubscribe = toastService.subscribe(toast => {
      setToasts(prev => [...prev, toast]);
    });

    const unsubscribeRemove = toastService.subscribeRemove(id => {
      setToasts(prev => prev.filter(t => t.id !== id));
    });

    return () => {
      unsubscribe();
      unsubscribeRemove();
    };
  }, []);

  const dismissToast = useCallback((id: string) => {
    toastService.remove(id);
  }, []);

  return { toasts, dismissToast };
}
